import React, { useEffect, useState } from "react";
import { deleteDoc, doc, db } from "../services/dbMariaFirestoreCompat";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { getCachedCollection, removeCachedRecord } from "../services/firestoreCache";

const MyBikes: React.FC = () => {
  const { currentUser, producerInfo } = useAuth();
  const [bikes, setBikes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchBikes = async (forceRefresh: boolean = false) => {
    if (!currentUser || !producerInfo?.brand) {
      setError("No permissions or producer information.");
      setLoading(false);
      return;
    }
    try {
      const allBikes = await getCachedCollection("bikeFrames", {
        maxAgeMs: 5 * 60 * 1000,
        forceRefresh
      });
      const filtered = allBikes.filter((bike: any) =>
        String(bike.producent || bike.producer || "").toLowerCase() === String(producerInfo.brand).toLowerCase()
      );
      setBikes(filtered);
      setError("");
    } catch (e) {
      setError("Error fetching bikes.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBikes(false);
  }, [currentUser, producerInfo]);

  const handleRefresh = async () => {
    setLoading(true);
    setError("");
    await fetchBikes(true);
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this bike?")) return;
    try {
      await deleteDoc(doc(db, "bikeFrames", id));
      removeCachedRecord("bikeFrames", id);
      setBikes(prev => prev.filter(b => b.id !== id));
    } catch (e) {
      alert("Error deleting bike.");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div style={{ color: "#ff6b6b" }}>{error}</div>;

  return (
    <div style={{ maxWidth: 800, margin: "40px auto", background: "#112240", padding: 24, borderRadius: 8, color: "#e6f1ff" }}>
      <h2 style={{ color: "#64ffda" }}>My bikes ({producerInfo?.brand})</h2>
      <button
        style={{ background: "#64ffda", color: "#0a192f", border: "none", borderRadius: 4, padding: "8px 18px", fontWeight: "bold", marginBottom: 18, cursor: "pointer" }}
        onClick={() => navigate("/add-bike")}
      >Add bike</button>
      <button
        style={{ background: "#64ffda", color: "#0a192f", border: "none", borderRadius: 4, padding: "8px 18px", fontWeight: "bold", marginBottom: 18, cursor: loading ? "not-allowed" : "pointer", marginLeft: 8, opacity: loading ? 0.6 : 1 }}
        onClick={handleRefresh}
        disabled={loading}
      >Refresh cache/db</button>
      {bikes.length === 0 ? (
        <div>No bikes for this brand.</div>
      ) : (
        <table style={{ width: "100%", marginTop: 16, background: "#0a192f", borderRadius: 4 }}>
          <thead>
            <tr>
              <th style={{ color: "#64ffda" }}>Model</th>
              <th style={{ color: "#64ffda" }}>Year</th>
              <th style={{ color: "#64ffda" }}>Size</th>
              <th style={{ color: "#64ffda" }}>Certificated</th>
              <th style={{ color: "#64ffda" }}>Archival</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {bikes.map(bike => (
              <tr key={bike.id}>
                <td>{bike.model}</td>
                <td>{bike.rok || bike.year}</td>
                <td>{bike.rozmiar || bike.size}</td>
                <td>{bike.certificated ? "YES" : "NO"}</td>
                <td>{bike.archival ? "YES" : "NO"}</td>
                <td>
                  <button onClick={() => handleDelete(bike.id)} style={{ background: "#f44336", color: "white", border: "none", borderRadius: 4, padding: "4px 10px", cursor: "pointer" }}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MyBikes;
